var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayoutSticky = function SvgLayoutSticky(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-1",
    d: "M64 51v2H8v-2h6V41c0-1.1.9-2 2-2h40c1.1 0 2 .9 2 2v10h6Z",
    fill: "#80B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-3",
    d: "M49 45H23v2h26v-2Z",
    fill: "#EBF2FF"
  })));
};
export default SvgLayoutSticky;